import React from 'react';
import { ClipLoader } from 'react-spinners';

interface Props {
  size?: number;
  title?: string;
  color?: string;
}

export const OperationLoader: React.FC<Props> = props => {
  const size = props.size || 16;
  const title = props.title || null;
  const color = props.color || 'magenta';

  return (
    <span className="operation loader" title={title}>
      <ClipLoader size={size} color={color} />
    </span>
  );
};

export default OperationLoader;
